/* eslint-disable no-console */

import { register } from 'register-service-worker'

// Garde-fou anti-boucle : si le service worker annonce une « nouvelle version »
// à chaque chargement (sw.js servi depuis un cache ou par deux versions du
// déploiement), un rechargement inconditionnel recharge indéfiniment. On ne
// recharge donc qu'une fois par minute et par onglet ; sans sessionStorage on
// ne recharge pas du tout (la version à jour est prise à la prochaine visite).
const RELOAD_KEY = 'bo-sw-reload-at'
const RELOAD_MIN_DELAY_MS = 60 * 1000

function rechargerUneFois () {
  try {
    const last = Number(window.sessionStorage.getItem(RELOAD_KEY) || 0)
    if (Date.now() - last < RELOAD_MIN_DELAY_MS) return
    window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  } catch (e) {
    return
  }
  window.location.reload()
}

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}sw.js`, {
    ready () {
      console.log('PWA prête (cache).')
    },
    registered (registration) {
      console.log('Service worker enregistré.')
      // Vérification périodique des updates
      setInterval(() => {
        registration.update()
      }, 1000 * 60 * 5) // toutes les 5 minutes
    },
    cached () {
      console.log('Contenu mis en cache pour usage offline.')
    },
    updatefound () {
      console.log('Nouveau contenu en cours de téléchargement…')
    },
    updated (registration) {
      console.log('Nouveau contenu disponible. Activation immédiate…')
      // Force activation immédiate
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      }
      // Rechargement de la page pour servir la nouvelle version
      rechargerUneFois()
    },
    offline () {
      console.log('Connexion internet absente, mode hors-ligne.')
    },
    error (error) {
      console.error('Erreur d\'enregistrement SW:', error)
    }
  })
}

// Ecoute du message skipWaiting
navigator.serviceWorker?.addEventListener('controllerchange', () => {
  console.log('Service worker actif mis à jour.')
})
